<div class="permit-signature" *transloco="let t; read:'permit.signature'">
    <h2 class="permit-signature__heading" [innerHTML]="t('heading')"></h2>
    <div class="permit-signature__signtext" *ngIf="(isSuperintendentFlow$ | async) === true" [innerHTML]="t('signTextSuperintendentFlow')"></div>
    <div class="permit-signature__signtext" *ngIf="(isSuperintendentFlow$ | async) === false && (isFlammableHotWork$ | async) === false" [innerHTML]="t('signTextForFlammableHotWork')"></div>
    <div class="permit-signature__signtext" *ngIf="(isSuperintendentFlow$ | async) === false && (isFlammableHotWork$ | async) === true" [innerHTML]="t('signText')"></div>
    <ng-container *ngIf="team$ | async as team">
        <ng-container *ngIf="(isSuperintendentFlow$ | async) === true">
            <div class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.superintendent')"></h3>
                <ng-container *ngIf="team.superintendent" [ngTemplateOutlet]="item"
                              [ngTemplateOutletContext]="{teamMembers: [team.superintendent]}">
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="(isSuperintendentFlow$ | async) === false && (isFlammableHotWork$ | async) === false">
            <div class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.permitissuer')"></h3>
                <ng-container *ngIf="team.permitIssuer" [ngTemplateOutlet]="item"
                              [ngTemplateOutletContext]="{teamMembers: [team.permitIssuer]}">
                </ng-container>
            </div>

        <ng-container *ngIf="(isFlammableHotWork$ | async) === false && team.hotWorkers.length > 0">
            <div class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.hotworker')"></h3>
                <ng-container *ngIf="team.hotWorkers" [ngTemplateOutlet]="textitem"
                              [ngTemplateOutletContext]="{teamMembers: team.hotWorkers}">
                </ng-container>
            </div>
        </ng-container>
        </ng-container>

        <ng-container *ngIf="(isSuperintendentFlow$ | async) === false && (isFlammableHotWork$ | async) === true">
            <div class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.permitissuer')"></h3>
                <ng-container *ngIf="team.permitIssuer" [ngTemplateOutlet]="item"
                              [ngTemplateOutletContext]="{teamMembers: [team.permitIssuer]}">
                </ng-container>
            </div>

            <div class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.hotworker')"></h3>
                <ng-container *ngIf="team.hotWorkers" [ngTemplateOutlet]="item"
                              [ngTemplateOutletContext]="{teamMembers: team.hotWorkers}">
                </ng-container>
            </div>

            <div *ngIf="!team.fireWatchersNotNeeded" class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.firewatcher')"></h3>
                <ng-container *ngIf="team.fireWatchers" [ngTemplateOutlet]="item"
                              [ngTemplateOutletContext]="{teamMembers: team.fireWatchers}">
                </ng-container>
            </div>

            <div class="permit-signature__role">
                <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.postfirewatcher')"></h3>
                <ng-container *ngIf="team.postFireWatchers" [ngTemplateOutlet]="item"
                              [ngTemplateOutletContext]="{teamMembers: team.postFireWatchers}">
                </ng-container>
            </div>

            <div class="permit-signature__role" *ngIf="workplaceDetails$ | async as workplace">
                <div *ngIf="workplace.allowCounterSignature">
                    <h3 class="permit-signature__role__heading" [innerHTML]="t('roles.counterSign')"></h3>
                    <ng-container [ngTemplateOutlet]="counterSign"
                                [ngTemplateOutletContext]="{teamMembers: team.countersignPermits}">
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <div class="permit-signature__actions">
        <button class="permit-signature__actions__back" type="button" (click)="back()">{{ t("back") }}</button>
        <button class="permit-signature__actions__continue" type="button" (click)="continue()"
                [class.permit-signature__actions__continue--disabled]="(teamSigned$ | async) === false">
            {{ t("next") }}
        </button>
    </div>

    <ng-template #item let-teamMembers="teamMembers">
        <div class="permit-signature__role__person-list">
            <div *ngFor="let teamMember of teamMembers" class="permit-signature__role__person-list__item"
                 [class.permit-signature__role__person-list__item--signed]="teamMember?.signature || signatureNotRequired(teamMember)"
                 (click)="showSignPerson(teamMember)">
                <div class="permit-signature__role__person-list__item__text">{{teamMember.firstName}} {{teamMember.lastName}}</div>
                <div class="permit-signature__role__person-list__item__sign"></div>
            </div>
        </div>
    </ng-template>

    <ng-template #textitem let-teamMembers="teamMembers">
        <div class="permit-signature__role__text-member-list">
            <div *ngFor="let teamMember of teamMembers" class="permit-signature__role__text-member-list__textitem">
                <div class="permit-signature__role__text-member-list__textitem__text">{{teamMember.firstName}} {{teamMember.lastName}}</div>
            </div>
        </div>
    </ng-template>

    <ng-template #counterSign let-teamMembers="teamMembers" let-personRole="personRole">
        <div class="permit-signature__role__countersign-list">
            <div *ngFor="let teamMember of teamMembers" class="permit-signature__role__countersign-list__textitem"
                    (click)="removeCountersign(teamMember)">
                <div class="permit-signature__role__countersign-list__textitem__text">{{teamMember.member}} ({{
                        teamMember.role === CountersignRole.OtherRole
                        ? teamMember.freeTextRole
                        : t(roleLabels[teamMember.role],{scope: null})
                    }})</div>
                <div class="permit-signature__role__countersign-list__textitem__delete"></div>
            </div>
            <div class="permit-signature__role__countersign-list__add" (click)="addCountersign()"></div>
        </div>
    </ng-template>

</div>
